//import { ENV } from "../../../components/services/login/app.config";
//const sigvial_maps_host = ENV.BUILDER.host;
import store from '../../../store';

L.GeodirLegend = L.Control.extend({
    options:{
    	container: '',
        position : 'bottomleft',
        title: 'Leyenda',
        showNumRecords: false,
        url_layers: '/geodir/ext/layer/json',
        maxHeight: 300
    },
    initialize: function(options){
    	L.Util.setOptions(this, options || {});
    },
    onAdd: function(map){
    	this._map = map;
        this._container = L.DomUtil.create('div', 'leaflet-control-legend');
		this._containerLegend = this._createLegendContainer();
        this._button = this._createButton();

        return this._container;
    },    
    addTo: function (map) {
    	if(this.options.container){
    		this._container = this.onAdd(map);
			this._wrapper = L.DomUtil.get(this.options.container);
			this._wrapper.style.position = 'relative';
			this._wrapper.appendChild(this._container);
    	}else
    		L.Control.prototype.addTo.call(this, map);
    	
    	return this;
    },    
    addItemLegend: function(layer) {
    },
    removeItemLegend: function(layer) {
    },
    updateItemLegend: function(layer) {
    },    
    _createTitle: function(container) {
    	let title = L.DomUtil.create('div', 'legend-title', container);
    	title.innerHTML = "<b>" + this.options.title + "</b>";
    	
    	let closeButton = L.DomUtil.create('a', 'legend-close', title);
		closeButton.href = "#";
    	closeButton.innerHTML = "<span>&times;</span>";
		L.DomEvent.on(closeButton, 'click', L.DomEvent.stop, this)
			.on(closeButton, 'click', this._closeLegend, this);
					
    	return title;
    },    
    _createLegendContainer: function() {
    	let containerLegend = L.DomUtil.create('div', 'legend-container', this._container);
    	containerLegend.style.display = 'none';
    	// L.DomEvent.on(containerLegend, 'mouseleave', L.DomEvent.stop, this)
   		// 	.on(containerLegend, 'mouseleave', this._closeLegend, this);
    	let title = this._createTitle(containerLegend);
    	
    	return containerLegend;
    },    
    _createButton: function() {
    	let button = L.DomUtil.create('a', 'legend-button', this._container);
		//let span = L.DomUtil.create('span', 'sigvial-icon-place', button);
		button.id = 'legend-button';
		//button.style.display = 'none';
    	button.href = '#';
		button.title = this.options.title;
		button.innerHTML  = 'Leyenda';
		L.DomEvent.on(button, 'click', L.DomEvent.stop, this)
			.on(button, 'click', this._openLegend, this);
		//	.on(button, 'mouseover', this._openLegend, this);
		
		return button;
    },
    _openLegend: function(){
		console.log('Abrir leyenda');
    	this._button.style.display = 'none';
		this._containerLegend.style.display = 'block';		
		this._itemsLegend = this._buildItemsLegend(this._containerLegend);
		
    	return this;
    },    
    _closeLegend: function() {
		if (this._containerLegend.style.display  ==  'block') {
			this._containerLegend.style.display = 'none';
			this._button.style.display = 'block';
			document.getElementById('legend-items-content').remove();
		}

		return this;
	},
	_buildItemsLegend: function(container){
		console.log('recorrer items leyenda');
		let divContent = L.DomUtil.create('div', 'legend-items-content', container);
		divContent.id = 'legend-items-content';
		divContent.style.background = 'url("src/assets/img/loading-two.gif") no-repeat 100px';
		divContent.style.backgroundSize = '30px';
		divContent.style.padding = '15px';
		divContent.style.maxHeight = this.options.maxHeight + 'px';
        let containerItems = L.DomUtil.create('ul', 'legend-items list-group', divContent);
		
		setTimeout(function() {
			divContent.style.padding = '5px';		
			this.layers = store.state.layers;

			const defaultLegendParams = {
				request: 'GetLegendGraphic',
				version : '1.0.0',
				format : 'image/png',
				width : 20,
				heigth : 20,
				service: 'WMS',
				SLD_VERSION : '1.0.0',
				LEGEND_OPTIONS : "countMatched:true;fontName:'myFirstFont';fontStyle:bold;fontAntiAliasing:true;fontColor:0x000000;fontSize:10;bgColor:0x000000"
			};

			let selfDefaultLegendParams = defaultLegendParams;

			for (let layer in this.layers){
				let legendLayer = this.layers[layer];

				if (legendLayer.visible ) {
					let item = L.DomUtil.create('li', 'legend-item list-group-item', containerItems);

					if (legendLayer.id != 9999) {
						let paramsLegend = {
							request : selfDefaultLegendParams.request,
							service : selfDefaultLegendParams.service,
							SLD_VERSION : selfDefaultLegendParams.SLD_VERSION,
							transparent : true,
							version : selfDefaultLegendParams.version,
							format : selfDefaultLegendParams.format,
							layer : legendLayer.layer,
							geodirParam : Math.random(),
							WIDTH : selfDefaultLegendParams.width,
							HEIGHT : selfDefaultLegendParams.heigth,
							LEGEND_OPTIONS : selfDefaultLegendParams.LEGEND_OPTIONS,
						};
						
						if (legendLayer.sld != null) {
							paramsLegend.sld = legendLayer.sld;
						}

						let srcImg = legendLayer.wmsUrl + L.Util.getParamString(paramsLegend, legendLayer.wmsUrl, true);
						let contentImg = L.DomUtil.create('div', 'legend-image', item);
						let image = L.DomUtil.create('img', '', contentImg);
						image.src = srcImg;					
					}
					else {
						console.log(legendLayer);
					}
					
					let text = L.DomUtil.create('p', 'legend-text', item);
					text.innerHTML = legendLayer.alias;
				}
			}

			/* if (this.options.url_layers) {
				let selfDefaultLegendParams = this.defaultLegendParams;

				$.getJSON(this.options.url_layers, function(layers) {				
					for (let layer in layers) {
						console(layer);
						let legendLayer = layers[layer];
						
						if (legendLayer.visible ) {
							let item = L.DomUtil.create('li', 'legend-item list-group-item', containerItems);

							if (legendLayer.id != 9999) {
								let paramsLegend = {
									request : selfDefaultLegendParams.request,
									service : selfDefaultLegendParams.service,
									SLD_VERSION : selfDefaultLegendParams.SLD_VERSION,
									transparent : true,
									version : selfDefaultLegendParams.version,
									format : selfDefaultLegendParams.format,
									layer : legendLayer.layer,
									geodirParam : Math.random(),
									WIDTH : selfDefaultLegendParams.width,
									HEIGHT : selfDefaultLegendParams.heigth,
									LEGEND_OPTIONS : selfDefaultLegendParams.LEGEND_OPTIONS,
								};
								
								if (legendLayer.sld != null) {
									paramsLegend.sld = legendLayer.sld;
								}
								let srcImg = legendLayer.wmsUrl + L.Util.getParamString(paramsLegend, legendLayer.wmsUrl, true);
								let contentImg = L.DomUtil.create('div', 'legend-image', item);
								let image = L.DomUtil.create('img', '', contentImg);
								image.src = srcImg;
								
							} else {
								console.log(legendLayer);
							}
							
							let text = L.DomUtil.create('b', 'legend-text', item);
							text.innerHTML = legendLayer.alias;
						}					
					}
				});			
			}*/

			return containerItems;
		}, 2000);
	}    
});

L.geodirLegend = function(options){
	return new L.GeodirLegend(options);
};